<dx-donut-chart label="{{value}} %" sublabel="Rabatt">
    <dx-media-query-value property="labelsize" mq1="m" mq2="m" mq3="l" mq4="l"></dx-media-query-value>
    <dx-chart-sample value="{{value * 4}}"></dx-chart-sample>
    <dx-chart-sample [color]="'gray-7'" value="{{100 - value * 4}}"></dx-chart-sample>
</dx-donut-chart>
